import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { ActionSteps } from './ActionSteps/ActionSteps';
import { Suggestions } from './Suggestions/Suggestions';
import { useIsCurrentPlanSelected } from '../../hooks/useIsCurrentPlanSelected';

interface TasksProps {
  goalId?: string;
  debtType?: number;
}

export const Tasks = ({ goalId, debtType }: TasksProps) => {
  const { isCurrentPlanSelected } = useIsCurrentPlanSelected();

  if (isCurrentPlanSelected) {
    return null;
  }

  return (
    <Box display="flex" mt="16" alignItems="stretch" css="page-break-inside: avoid">
      <Box width="100%" mr="8" pb="8">
        <ActionSteps goalId={goalId} debtType={debtType} />
      </Box>

      <Box width="100%" ml="8" pb="8">
        <Suggestions goalId={goalId} debtType={debtType} />
      </Box>
    </Box>
  );
};
